import {J3PanelBase} from './J3PanelBase';

export class J3TagPanel extends J3PanelBase{
    id:string;

    constructor(debugLvl = 0, name = '', enable=true, show=false, visible=true, btnContainerID:string, onOffButtonID:string, iconOnFile:string, iconOffFile:string){
        super();
        this.name = name;
        console.log('J3TagPanel', onOffButtonID);
        this.id = onOffButtonID.split('_')[1];
        const btnContainer = document.querySelector('#' + btnContainerID) as HTMLElement;

        if(enable){
            if(btnContainer){
                const li = document.createElement('li');
                li.setAttribute("id", onOffButtonID);   //li要素にIDを追加
                this.MakeOnOffButtonDOM(li, iconOnFile, iconOffFile);
                btnContainer.appendChild(li);
                this.SetButtons(onOffButtonID);

                //elem.innerHTML = '';    //子要素をすべて削除
                //const htmlText1 = '<ul class="list-inline"><li class="btnOff"><figure><button type="button"><img src="' + iconOffFile + '" alt="セクションメニューオフ"></button></figure></li>';
                //const htmlText2 = '<li class="btnOn"><figure><button type="button"><img src="' + iconOnFile + '" alt="セクションメニューオン"></button></figure></li></ul>';
                //elem.innerHTML = htmlText1 + htmlText2;
                this.SetButtons(onOffButtonID);

                if (visible){
                    this.ShowButton(li);
                }else{
                    this.HideButton(li);
                }
            }
        }
    }
}